import type { CityConfig } from "../city-template/types";

export const newtonIAConfig: CityConfig = {
  city: "Newton",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "newton-ia",
  route: "/cities/newton-ia",
  title: "Emergency Passport Newton, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Newton, IA — as fast as 24 hours. Serving Jasper County and Central Iowa. A+ BBB rated registered State Dept. courier serving TPI Composites and Wind Energy professionals, Iowa Speedway NASCAR travelers, and DMACC Newton campus community. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Newton, IA",
  heroSubtitle: "TPI Composites wind blade deployment to Denmark with a week's notice and your passport expired? Iowa Speedway NASCAR international race event and crew needs documents fast? DMACC study abroad program starting next week? We help Newton and Jasper County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Newton%20Iowa%20historic%20Jasper%20County%20Courthouse%20on%20town%20square%20with%20brick%20downtown%20buildings%20Iowa%20Speedway%20NASCAR%20track%20in%20distance%20Central%20Iowa%20manufacturing%20and%20racing%20community%20at%20golden%20hour%20warm%20sunlight%20motorsports%20heritage&width=1800&height=700&seq=newton-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Newton Iowa historic downtown and Iowa Speedway NASCAR track Jasper County Central Iowa at golden hour",
  geoPosition: "41.6997;-93.0497",
  geoPlacename: "Newton, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 320 miles east of Newton via I-80",
  },
  nearbyCitiesZips: [
    { name: "Newton", zips: "50208" },
    { name: "Colfax", zips: "50054" },
    { name: "Monroe", zips: "50170" },
    { name: "Prairie City", zips: "50228" },
    { name: "Baxter", zips: "50028" },
    { name: "Sully", zips: "50251" },
    { name: "Grinnell", zips: "50112" },
    { name: "Pella", zips: "50219" },
    { name: "Knoxville", zips: "50138" },
    { name: "Altoona", zips: "50009" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Marshalltown", zips: "50158" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Indianola", zips: "50125" },
    { name: "Oskaloosa", zips: "52577" },
    { name: "Coralville", zips: "52241" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Jasper County Coverage", desc: "Serving Newton, Colfax, Monroe, and Central Iowa" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in Pella, IA", route: "/cities/pella" },
    { name: "Emergency passport help in Grinnell, IA", route: "/cities/grinnell" },
    { name: "Urgent passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Same-day passport help in Ames, IA", route: "/cities/ames" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Newton remotely via secure courier. We do not have a walk-in office in Newton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Jasper County and the entire Central Iowa region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Jasper County and the Central Iowa region including Colfax, Monroe, Prairie City, and surrounding communities",
  serviceAreaIntro: "From TPI Composites manufacturing wind turbine blades for the global renewable energy market to Iowa Speedway hosting NASCAR and IndyCar events drawing international teams, from the DMACC Newton campus serving Central Iowa students to the historic Jasper County Courthouse on the town square, from the Maytag historical legacy at Maytag Park to the growing manufacturing corridor along I-80 — Fast Passport Center serves the entire Newton region. We regularly help travelers from Newton, Colfax, Monroe, and Prairie City get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Newton neighborhoods and the surrounding Central Iowa area including Colfax, Monroe, Prairie City, Baxter, Sully, Grinnell, and Pella. If you are anywhere in Jasper County or Central Iowa, we have you covered.",
  howItWorksIntro: "Most Newton travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Central Iowa travelers often face a 5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Newton and Jasper County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Newton? Here are the most common ones we hear from Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Newton travelers with immediate departure needs — as fast as 24 hours for urgent international flights from DSM.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Jasper County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Erik J.",
      location: "Newton, IA",
      rating: 5,
      text: "TPI Composites sent me to our blade testing facility in Denmark with 5 days notice. Fast Passport Center renewed my passport in 2 days. My engineering team lead was floored. Now every international deployment goes through them.",
      service: "Passport Renewal",
    },
    {
      name: "Chris D.",
      location: "Newton, IA",
      rating: 5,
      text: "Iowa Speedway NASCAR crew heading to a race in Canada — realized my passport expired 4 days before. Fast Passport Center got it in 48 hours. I was in the pits on race day. The crew chief now keeps their card in his wallet.",
      service: "Emergency Passport",
    },
    {
      name: "Angela and Mark S.",
      location: "Colfax, IA",
      rating: 5,
      text: "Honeymoon to Greece — booked everything and realized 5 days before that we never got passports. Fast Passport Center got both new passports in 4 days. We made it to Santorini for the sunset photos of a lifetime!",
      service: "New Passport",
    },

  ],
  facilities: [
    {
      id: "newton-ia-1",
      name: "Newton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 1st Ave E",
      city: "Newton",
      state: "IA",
      zip: "50208",
      phone: "(641) 792-4211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Newton facility. Serves Jasper County. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "newton-ia-2",
      name: "Jasper County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "101 1st St N",
      city: "Newton",
      state: "IA",
      zip: "50208",
      phone: "(641) 792-7831",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Jasper County Courthouse",
      website: "https://www.jaspercountyiowa.gov/recorder",
      websiteLabel: "Jasper County Recorder",
      notes: "Accepts passport applications at the courthouse. Extended weekday hours. Good alternative.",
      icon: "ri-government-line",
    },
    {
      id: "newton-ia-3",
      name: "Grinnell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "921 4th Ave",
      city: "Grinnell",
      state: "IA",
      zip: "50112",
      phone: "(641) 236-7531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles east of Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Poweshiek County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "newton-ia-4",
      name: "Colfax Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21 E Howard St",
      city: "Colfax",
      state: "IA",
      zip: "50054",
      phone: "(515) 674-3311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles west of Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Colfax and western Jasper County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "newton-ia-5",
      name: "Monroe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "114 S Monroe St",
      city: "Monroe",
      state: "IA",
      zip: "50170",
      phone: "(641) 259-2711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Monroe and southern Jasper County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "newton-ia-6",
      name: "Pella Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "703 Main St",
      city: "Pella",
      state: "IA",
      zip: "50219",
      phone: "(641) 628-4021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southeast of Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marion County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photo shops in Central Iowa often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Jasper County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Newton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Newton Community School District families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Newton travelers often assume manufacturing travel departments handle everything. Always check your passport 6 months before international travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Newton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Newton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Newton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Newton for travelers with urgent international flights from DSM. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Newton?", a: "Fast Passport Center offers fast passport renewal in Newton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Newton?", a: "The nearest regional passport agency to Newton is the Chicago Passport Agency, approximately 320 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Newton without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Newton?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Newton — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Jasper County and Central Iowa residents." },
    { q: "Do you serve TPI Composites and Iowa Speedway workers?", a: "Absolutely. Fast Passport Center regularly serves TPI Composites wind energy professionals and Iowa Speedway racing crew members needing fast passports for international events. Our courier service handles everything online — no time off work needed." },
    { q: "Can I expedite a child passport in Newton?", a: "Yes. Fast Passport Center expedites child passports in Newton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Jasper County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Newton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Newton", address: "300 Iowa Speedway Dr, Newton, IA 50208", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Newton", address: "111 1st Ave E, Newton, IA 50208", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Grinnell", address: "1310 W St S, Grinnell, IA 50112", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — Altoona", address: "3501 8th St SW, Altoona, IA 50009", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Des Moines", address: "3400 SE 14th St, Des Moines, IA 50320", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Newton Driver's License",
      address: "2112 S 24th Ave W, Newton, IA 50208",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Jasper County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Grinnell Driver's License",
      address: "220 4th Ave W, Grinnell, IA 50112",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Poweshiek County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Marshalltown Driver's License",
      address: "3408 S Center St, Marshalltown, IA 50158",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Marshall County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "40 miles west of Newton",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 40 minutes from Newton.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "80 miles east of Newton",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 1 hour 15 minutes from Newton.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "OTM",
      name: "Ottumwa Regional Airport",
      distance: "70 miles southeast of Newton",
      address: "14802 Terminal St, Ottumwa, IA 52501",
      note: "Regional airport with charter services. About 1 hour 15 minutes from Newton.",
      flightUrl: "https://www.ottumwa.us/departments/airport/",
      flightLabel: "OTM Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Iowa Department of Health and Human Services Vital Records in Des Moines — order certified birth and death certificates for Jasper County residents online, by mail, or in person.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Jasper County Recorder — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.jaspercountyiowa.gov/recorder" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Jasper County Clerk of Court — certified divorce decrees supporting passport name change or correction.", url: "https://www.iowacourts.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Iowa, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};